import { useEffect } from "react"

import { useEvpIssue } from "@/api/useEvp"

import type { Actions } from "@/organisms/Drawers/hooks/useTabs"

// Both EVP tabs (Exploit Validation + Remediation) are available only for issues
// that have exploitability data. They start disabled (see the drawer's INITIAL_STATE)
// and get enabled here once the exploitability query resolves with an enriched
// verdict. Kept lightweight (no selector import) so it stays out of the lazy chunk.
export const useEvpTabAvailability = (
  tabName: string,
  issueId: string | undefined,
  actions: Actions
) => {
  const { response, isLoading } = useEvpIssue(issueId)

  useEffect(() => {
    if (isLoading) return

    const hasExploitabilityData =
      !!response && response.verdict !== "undetermined"

    actions.onChangeTabAvailability(tabName, hasExploitabilityData)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading, response])
}
